module.exports = __webpack_public_path__ + "media/images/demo/toggle-overlay-menu-dd078a6c8a863c916e517ba93d47cd8a.jpg";